import getSecretStorageKey from "./secretStorage";
let secretStorageKeys = {};
let secretStorageKeyInfo = {};
let secretStorageBeingAccessed = false;
function isCachingAllowed() {
    return secretStorageBeingAccessed;
}
function cacheSecretStorageKey(keyId, keyInfo, key) {
    if (isCachingAllowed()) {
        secretStorageKeys[keyId] = key;
        secretStorageKeyInfo[keyId] = keyInfo;
    }
}
export const crossSigningCallbacks = {
    getSecretStorageKey,
    cacheSecretStorageKey,
};
